// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__HC0Hp","description":"PatientConsentPreview_description__IzGae"};